import { Box, Wrap, WrapItem, Center } from "@chakra-ui/react";
import NavBar from "./components/NavBar";
import { generators, chats } from "./generators";
import Preview from "./components/Preview";
import { useQueryParameters } from "./lib/hooks";
import { useEffect } from "react";
import { hotjar } from "react-hotjar";
import { Analytics } from '@vercel/analytics/react';
import toast, { Toaster } from 'react-hot-toast';

function App() {
  const query = useQueryParameters();

  useEffect(() => {
    if (query.get("upgraded")) {
      toast.success("Your subscription was succesful");
    }
    hotjar.initialize(3353205, 6);
  }, []);

  return (
    <>
      <NavBar />
      <Center>
        <Box m="10">
          <Wrap spacing="15px" wrap="wrap-reverse" className="wrap-container">
            {chats
              .filter(
                (generator) =>
                  generator.env && generator.env.includes(process.env.NODE_ENV)
              )
              .map((generator, index) => {
                const { image, title, content, tags } = generator.preview;
                return (
                  <WrapItem margin="auto !important" key={index}>
                    <Preview
                      path={generator.path}
                      tags={tags}
                      image={image}
                      title={title}
                      content={content}
                    />
                  </WrapItem>
                );
              })}
            {generators
              .filter(
                (generator) =>
                  generator.env && generator.env.includes(process.env.NODE_ENV)
              )
              .map((generator, index) => {
                const { image, title, content, tags } = generator.preview;
                return (
                  <WrapItem margin="auto !important" key={index}>
                    <Preview
                      path={generator.path}
                      tags={tags}
                      image={image}
                      title={title}
                      content={content}
                    />
                  </WrapItem>
                );
              })}
          </Wrap>
        </Box>
      </Center>
      <Analytics />
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
    </>
  );
}

export default App;
